<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">易耗品盘存损益异常情况登记</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <inventory ref="create" :userData="userData" :formByFather="form"></inventory>

          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitMaterial()" class="form-btn" type="success">确认提交易耗品盘点登记</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  // import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  // import Attachments from '@/components/Attachments'
  // import ApprovalItem from '@/components/ApprovalItem'

  import Inventory from '@/page/form/consumable/inventory'
  export default {
    components: {
      // ApprovalItemByCustom,
      Inventory,
      // ApprovalItem,
      // Attachments,
    },
    // mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          depId: '',
          consumables: [],
          time: '',
          json: true,
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.params.houseId && this.$route.params.houseId != 0) {
        this.form.houseId = this.$route.params.houseId / 1
      }
      if (this.$route.params.projectId) {
        this.form.projectId = this.$route.params.projectId / 1
      }
    },
    methods: {
      // 提交使用易耗品申请单
      SubmitMaterial() {
        this.form = this.$refs.create.getFromData()

        // this.form.approvalType = this.approvalType
        // this.form.approvalUserIds = this.$refs.approval.getUserIds()
        // if (!this.form.approvalUserIds) {
        //   this.$message.error('审批人员不能一个都不选择')
        //   return
        // }
        // this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        // let _url = !this.form.applyId ? '/storage/material/use' : '/storage/material/use/edit?applyId=' + this.form.applyId

        ajax.post('/consumable/pan', this.form, (res) => {
          this.formLoading = false
          this.$message.success('提交盘点情况成功')
          this.$router.push('/Consumable/InventoryList')
        }, (res) => {
          this.formLoading = false
        })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/page/consumable/Inventory.vue